import PublishHeader from '../../components/header/PublishHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import astronaut from '../../assets/illustrations/astronaut.png';
import './publish.css';

interface PublishProps {
  setBlob: React.Dispatch<React.SetStateAction<Blob | null>>;
}

const PublishError: React.FC<PublishProps> = ({ setBlob }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error || null;

  return (
    <>
      <PublishHeader
        clearBlob={() => setBlob(null)}
        onEditClick={() => navigate(-2)}
      />
      <div className="error-page">
        <div className="error-page-content">
          <div className="error-404">
            4<span>Oh!</span>4
          </div>
          <p className="error-message-text">
            We are facing issues loading the video
          </p>
          <p className="error-message-text">{error}</p>
          <button className="go-back-button" onClick={() => navigate(-2)}>
            Go back
          </button>
        </div>
        <img
          src={astronaut}
          alt="Astronaut illustration"
          className="error-illustration"
        />
      </div>
    </>
  );
};

export default PublishError;
